module.exports = __webpack_public_path__ + "img/sqp.2069d676.png";